import api from './api'
import { ApiResponse, User, LoginForm } from '../types'

export interface LoginResponse {
  user: User
  token: string
}

export const authService = {
  // 用户登录
  login: async (credentials: LoginForm): Promise<LoginResponse> => {
    const response = await api.post<ApiResponse<LoginResponse>>('/auth/login', credentials)
    return response.data.data!
  },

  // 用户登出
  logout: async (): Promise<void> => {
    await api.post('/auth/logout')
  },

  // 获取当前用户信息
  getCurrentUser: async (): Promise<User> => {
    const response = await api.get<ApiResponse<User>>('/auth/me')
    return response.data.data!
  },

  // 验证token有效性
  validateToken: async (): Promise<boolean> => {
    try {
      await api.get('/auth/validate')
      return true
    } catch {
      return false
    }
  },
}